
  <div class="grid"
    *ngIf="conference$ | async as conference; then thenBlock else elseBlock"></div>

  <ng-template #thenBlock>
    <div class="sm:col-12 md:col-10 md:col-offset-1 lg:col-8 lg:col-offset-2 xl:col-6 xl:col-offset-3 ">


      <div class="content-section introduction">
        <div class="feature-intro text-center">
          <h1>Форма приема тезисов</h1>
          <p>Пошаговое заполнение информации о тезисе на конференцию</p>
          <p><b><u>&laquo;{{ confName }}&raquo;</u></b></p>
        </div>
      </div>

      <div class="content-section implementation">
        <div class="card" style="padding: 2em;">
          <p-toast></p-toast>
          <p-steps [model]="items" [readonly]="true"></p-steps>
        </div>
        <router-outlet></router-outlet>
      </div>

    </div>
  </ng-template>

  <ng-template #elseBlock>

    <div class="card text-center" style="margin-top: 25px;">
      <div class="card-header">
        Ошибка!
      </div>
      <div class="card-body">
        <h4 class="card-title">Регистрации тезисов по данному адресу не существует!</h4>
        <p class="card-text">Вернитесь на главную страницу</p>
        <a href="/" class="btn btn-outline-info">{{ 'На главную'.toUpperCase() }}</a>
      </div>
    </div>

  </ng-template>

